import { render } from "./PlanificareAnuala.vue?vue&type=template&id=a861a292&scoped=true&ts=true"
import script from "./PlanificareAnuala.vue?vue&type=script&lang=ts"
export * from "./PlanificareAnuala.vue?vue&type=script&lang=ts"

import "./PlanificareAnuala.vue?vue&type=style&index=0&id=a861a292&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a861a292"]])

export default __exports__